import { useGenerateBoloPdf } from '../state/use-generate-bolo-pdf';
import { useEnabledFeatures } from '~/common/hooks/enabled-features';
import { useAttachments } from '~/attachments/hooks/use-attachments';
import { ExportButton } from '~/common/components/export/export-button';
import { useCallback } from 'react';

interface BoloExportButtonProps {
    boloId: number;
}

export function BoloExportButton({ boloId }: BoloExportButtonProps) {
    const {
        generatePDFWithoutAttachments,
        generatePDFWithAttachments,
        isLoading,
    } = useGenerateBoloPdf();
    const { mediaAttachmentsEnabled } = useEnabledFeatures();
    const { data } = useAttachments({
        entityId: boloId,
        entityType: 'BOLO',
    });

    const hasAttachments = mediaAttachmentsEnabled && (data?.attachments?.length ?? 0) > 0;

    const handleExportPDF = useCallback(() => {
        generatePDFWithoutAttachments(boloId);
    }, [generatePDFWithoutAttachments, boloId]);

    const handleExportPDFWithAttachments = useCallback(() => {
        generatePDFWithAttachments(boloId);
    }, [generatePDFWithAttachments, boloId]);

    return (
        <ExportButton
            hasAttachments={hasAttachments}
            isLoading={isLoading}
            onExportPDF={handleExportPDF}
            onExportPDFWithAttachments={handleExportPDFWithAttachments}
        />
    );
}
